<div class="a3l-dataset-grid-renderer">
  <ng-container [ngTemplateOutlet]="element.templateRef" [ngTemplateOutletContext]="{ $implicit: item }" *ngFor="let item of dataset$ | async"></ng-container>
</div>
